import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Date = props => {
  var {
    Date: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Date');
  return null;
};
Date.displayName = 'JVR.Date';